module.exports = __webpack_public_path__ + "assets/img/9bb2-ir.svg";